import { Container, Stack } from '@mui/material';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export const CalculatorLayout = () => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Stack
      sx={{
        background:
          'linear-gradient(180deg, rgb(224, 243, 255) 0%, rgb(243, 250, 255) 100%)',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        color: '#081E54',
      }}
    >
      <Header />
      <Container component={'main'}>
        <Stack
          sx={{
            minHeight: 'calc(100vh - 72px - 100px)',
            justifyContent: 'center',
          }}
          direction={'row'}
          id='main-content'
        >
          <Outlet context={{ isLoading, setIsLoading }} />
        </Stack>
      </Container>
    </Stack>
  );
};
